<template>
  <v-card flat class="ma-n2 pa-0 cluster-popup-panel">
    <v-btn id="popupPanelCloseButton" text class="popup-panel-close-button d-sm-none ">
      <v-icon small>mdi-close</v-icon>
    </v-btn>
    <v-container fluid pa-0 pa-4>
      <v-row class="ma-0 pa-0 mt-1">
        <v-col cols="2" sm="2" md="2" class="ma-0 pa-0">
          <v-icon v-bind:style="{ color: markerColor10 }">mdi-weather-windy</v-icon>
        </v-col>
        <v-col
          sm="10"
          md="10"
          class="ma-0 pa-1"
        >Max. 10: {{ sensordata.maxPM10.toFixed(2) }} &#181;g/m&#179;</v-col>
      </v-row>
      <v-row class="ma-0 pa-0 mt-1">
        <v-col cols="2" sm="2" md="2" class="ma-0 pa-0">
          <v-icon v-bind:style="{ color: markerColor10 }">mdi-weather-windy</v-icon>
        </v-col>
        <v-col
          sm="10"
          md="10"
          class="ma-0 pa-1"
        >Śr 10: {{ sensordata.avgPM10.toFixed(2) }} &#181;g/m&#179;</v-col>
      </v-row>
      <v-row class="ma-0 pa-0 mt-1">
        <v-col cols="2" sm="2" md="42" class="ma-0 pa-0">
          <v-icon v-bind:style="{ color: markerColor25 }">mdi-weather-windy</v-icon>
        </v-col>
        <v-col
          sm="10"
          md="10"
          class="ma-0 pa-1"
        >Max. 2.5: {{ sensordata.maxPM25.toFixed(2) }} &#181;g/m&#179;</v-col>
      </v-row>
      <v-row class="ma-0 pa-0 mt-1">
        <v-col cols="2" sm="2" md="2" class="ma-0 pa-0">
          <v-icon v-bind:style="{ color: markerColor25 }">mdi-weather-windy</v-icon>
        </v-col>
        <v-col
          sm="10"
          md="10"
          class="ma-0 pa-1"
        >Śr 2.5: {{ sensordata.avgPM25.toFixed(2) }} &#181;g/m&#179;</v-col>
      </v-row>
      <v-row v-if="sensordata.maxPredictionPM10 !== undefined" class="ma-0 pa-0 mt-1">
        <v-col cols="2" sm="2" md="42" class="ma-0 pa-0">
          <v-icon v-bind:style="{ color: predictionMarkerColor10 }">mdi-weather-windy</v-icon>
        </v-col>
        <v-col
          sm="10"
          md="10"
          class="ma-0 pa-1"
        >Max. 10 <strong>za {{ sensordata.predictionHour }}h</strong>: {{ sensordata.maxPredictionPM10.toFixed(2) }} &#181;g/m&#179;</v-col>
      </v-row>
      <v-row v-if="sensordata.avgPredictionPM10 !== undefined" class="ma-0 pa-0 mt-1">
        <v-col cols="2" sm="2" md="2" class="ma-0 pa-0">
          <v-icon v-bind:style="{ color: predictionMarkerColor10}">mdi-weather-windy</v-icon>
        </v-col>
        <v-col
          sm="10"
          md="10"
          class="ma-0 pa-1"
        >Śr 10 <strong>za {{ sensordata.predictionHour }}h</strong>: {{ sensordata.avgPredictionPM10.toFixed(2) }} &#181;g/m&#179;</v-col>
      </v-row>
      <v-row v-if="sensordata.maxPredictionPM25 !== undefined" class="ma-0 pa-0 mt-1">
        <v-col cols="2" sm="2" md="42" class="ma-0 pa-0">
          <v-icon v-bind:style="{ color: predictionMarkerColor25 }">mdi-weather-windy</v-icon>
        </v-col>
        <v-col
          sm="10"
          md="10"
          class="ma-0 pa-1"
        >Max. 2.5 <strong>za {{ sensordata.predictionHour }}h</strong>: {{ sensordata.maxPredictionPM25.toFixed(2) }} &#181;g/m&#179;</v-col>
      </v-row>
      <v-row v-if="sensordata.avgPredictionPM25 !== undefined" class="ma-0 pa-0 mt-1">
        <v-col cols="2" sm="2" md="2" class="ma-0 pa-0">
          <v-icon v-bind:style="{ color: predictionMarkerColor25}">mdi-weather-windy</v-icon>
        </v-col>
        <v-col
          sm="10"
          md="10"
          class="ma-0 pa-1"
        >Śr 2.5 <strong>za {{ sensordata.predictionHour }}h</strong>: {{ sensordata.avgPredictionPM25.toFixed(2) }} &#181;g/m&#179;</v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn @click="close" text>Zamknij</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import SensorLimits from "../tools/SensorLimits";
export default {
  name: "AirQualityClusterPopupVue",
  data() {
    return {};
  },
  props: {
    sensordata: { type: Object }
  },
  methods: {
    close() {
      document.querySelector(".leaflet-popup-close-button").click();
    }
  },
  computed: {
    markerColor25: function() {
      let markerColor = "#58b109";
      if (this.sensordata) {
        let pm25 = this.sensordata.avgPM25;
        markerColor = SensorLimits.getLimitColor("PM25", pm25);
      }
      return markerColor;
    },
    markerColor10: function() {
      let markerColor = "#58b109";
      if (this.sensordata) {
        let pm10 = this.sensordata.avgPM10;
        markerColor = SensorLimits.getLimitColor("PM10", pm10);
      }
      return markerColor;
    },
    predictionMarkerColor25: function() {
      let markerColor = "#58b109";
      if (this.sensordata) {
        let pm25 = this.sensordata.avgPredictionPM25;
        markerColor = SensorLimits.getLimitColor("PM25", pm25);
      }
      return markerColor;
    },
    predictionMarkerColor10: function() {
      let markerColor = "#58b109";
      if (this.sensordata) {
        let pm10 = this.sensordata.avgPredictionPM10;
        markerColor = SensorLimits.getLimitColor("PM10", pm10);
      }
      return markerColor;
    }
  }
};
</script>
<style>
@media (min-width: 480px) {
  .cluster-popup-panel {
    width: 100%;
    margin: 0px;
  }
}

.leaflet-popup-close-button {
  background-color: #e60085 !important;
  color: #ffffff !important;
  position: fixed !important;
  right: 0px !important;
  min-width: 0px !important;
  width: 30px !important;
  height: 30px !important;
  border-radius: 0px !important;
  margin-right: 9px !important;
  margin-top: 15px !important;
  padding: 8px 0px 0px 0px !important;
  font-weight: normal !important;
}

.popup-panel-close-button {
  background-color: #e60085 !important;
  color: #ffffff !important;
  position: fixed !important;
  padding: 0px !important;
  right: 0px !important;
  min-width: 0px !important;
  width: 30px !important;
  height: 30px !important;
  border-radius: 0px !important;
  margin-right: 9px !important;
  margin-top: 15px !important;
}
</style>